<template>
    <iframe
      :src="iframeUrl" frameborder="0"
      width="100%" height="100%"
      id="publicIframe"
      @load="load"
    ></iframe>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  data(){
    return{
      iframeUrl:''
    }
  },
  created(){
    //在线设计报表
    if(this.getLastPartOfURL() == 'customSheet'){
      //this.iframeUrl =  'http://his.udi.fangzhima.com/jshERP-boot/jmreport/list'
      this.iframeUrl =  this.getBaseURL() + '/jshERP-boot/jmreport/list'
    }
    //H5在线生成
    if(this.getLastPartOfURL() == 'customTemplate'){
      //this.iframeUrl =  'http://his.udi.fangzhima.com/jshERP-boot/jmreport/list'
       this.iframeUrl =  process.env.VUE_APP_TEMPLATE
      //this.iframeUrl =  this.getBaseURL() + '/jshERP-boot/jmreport/list'
    }
  },
  methods: {
    load(){
      const urlParams = new URLSearchParams(window.location.search);

      const params = Object.fromEntries(urlParams.entries())

      window.addEventListener('message',e=>{
        console.log('message===>>>',e)
        this.$router.push(`/system/templateList`)
      })
      console.log('trace====params===>>>',params)
      // document.getElementById('publicIframe').contentWindow.postMessage(params , "*");
    },
    getLastPartOfURL() {
      var currentURL = window.location.href;
      currentURL = currentURL.split('?')[0]
      var parts = currentURL.split("/");
      return parts[parts.length - 1];
    },
    getBaseURL() {
      var currentURL = window.location.href;
      var urlParts = currentURL.split("/");
      var baseURL = urlParts[0] + "//" + urlParts[2];
      return baseURL;
    }
  }
}
</script>
<style >
.ant-layout-content>div:last-child{
  height: calc( 100% - 60px );
}
</style>